import { Grid, Paper } from '@mui/material'
import { AttachMoney } from '@mui/icons-material'
import { inject } from 'mobx-react'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import { IStores } from '../Stores'
import BillsTable from './billsTable/BillsTable'
import { PayProvidersSearchRequest } from 'src/viewModels/PayProvidersSearchRequest'

interface IBillsProps {
  loadBills?: (request: PayProvidersSearchRequest) => Promise<void>
  setCanSwitchOrganizations?: (canSwitch: boolean) => void
  storedRequest?: PayProvidersSearchRequest
}

class Bills extends React.Component<IBillsProps> {
  constructor(props: IBillsProps) {
    super(props)
  }

  public componentDidMount() {
    var request = this.props.storedRequest ?? new PayProvidersSearchRequest()
    this.props.loadBills!(request)
    this.props.setCanSwitchOrganizations!(true)
  }

  public componentWillUnmount() {
    this.props.setCanSwitchOrganizations!(false)
  }

  public render() {
    return (
      <>
        <Helmet>
          <title>Pay Providers</title>
        </Helmet>
        <ResponsiveAppBar title={'Pay Providers'} pageIcon={<AttachMoney />} />
        <Paper style={{ margin: '20px', height: '100%', paddingBottom: '20px' }}>
          <Grid container style={{ width: '100%' }}>
            <BillsTable />
          </Grid>
        </Paper>
      </>
    )
  }
}

const InjectedBills = inject<IStores, IBillsProps, Partial<IBillsProps>, any>(
  (stores: IStores) => ({
    loadBills: stores.billsStore.loadSurgeryPayProviderBills,
    setCanSwitchOrganizations: stores.global.setCanSwitchOrganizations,
    storedRequest: stores.global.payProviderRequest,
  })
)(Bills)

export default InjectedBills
